import * as React from 'react'
import { Box } from '@mui/material'
import { OSEIngest } from './OpenSciEd/OSEIngest'
import { PartnerContext } from './PartnerContext'
import { useParams } from 'infrastructure/routing'
import { useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { partnerIdAtom } from '../components/ingestion/atoms'

export function Test() {
  const { partnerId } = useParams()
  useSetAtom(partnerIdAtom)(partnerId ?? '')
  function PartnerComponent() {
    switch (partnerId) {
      case 'OpenSciEd':
        return <OSEIngest />
    }
    return <Box>Not Found: {partnerId}</Box>
  }

  return (
    <Box>
      <PartnerContext.Provider value={partnerId}>
        <PartnerComponent />
      </PartnerContext.Provider>
    </Box>
  )
}
